import { ISpecialize } from '../interface/specialize';
export class Specialize {
    constructor(public SpecializeId : number,public SpecializeText : string, public ImagePath){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/specialize.ts